
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.097 17.631a.75.75 0 00-.568.017c-3.314 1.473-6.862-.931-6.862-3.898 0-2.122 2.177-4.25 5.083-4.25 2.907 0 5.083 2.128 5.083 4.25a3.412 3.412 0 01-1.366 2.733.75.75 0 00-.221.936l.396.791-1.545-.579z"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.5 7.083c.052-.274.08-.553.083-.833 0-3.222-3.166-5.833-7.083-5.833C3.583.417.417 3.028.417 6.25a5.361 5.361 0 002.097 4.142l-1.68 2.941 4.115-1.646c.425.135.86.235 1.301.3"}})]),_c('path',{attrs:{"d":"M13.026 6.806a1.5 1.5 0 102.948.555l-2.948-.555zm1.557-.556l1.5.02v-.02h-1.5zm-14.166 0h-1.5v.032l1.5-.032zm2.097 4.142l1.303.744a1.5 1.5 0 00-.39-1.934l-.913 1.19zm-1.68 2.941L-.47 12.59a1.5 1.5 0 001.86 2.137l-.558-1.393zm4.115-1.646l.454-1.43a1.5 1.5 0 00-1.01.037l.556 1.393zM6.03 13.47a1.5 1.5 0 10.44-2.967l-.44 2.967zm9.944-6.11c.068-.36.104-.725.11-1.091l-3-.04a3.35 3.35 0 01-.058.576l2.948.555zm.11-1.11c0-4.31-4.124-7.334-8.584-7.334v3c3.373 0 5.583 2.199 5.583 4.333h3zM7.5-1.084c-4.46 0-8.583 3.024-8.583 7.333h3c0-2.134 2.21-4.333 5.583-4.333v-3zm-8.583 7.365a6.862 6.862 0 002.684 5.3l1.826-2.38a3.862 3.862 0 01-1.51-2.983l-3 .063zm2.295 3.366L-.47 12.589l2.605 1.489 1.68-2.942-2.604-1.488zm.179 5.078l4.115-1.647-1.114-2.785L.276 11.94l1.115 2.785zm3.104-1.61a9.76 9.76 0 001.535.355l.44-2.967a6.838 6.838 0 01-1.067-.247l-.908 2.86z","mask":"url(#a)"}})])
          )
        }
      }
    